import { render } from "./ProductWarehouse.vue?vue&type=template&id=f9c46caa"
import script from "./ProductWarehouse.vue?vue&type=script&lang=js"
export * from "./ProductWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__